const Input = ({ name, value, label, error, onChange, disabled }) => {
  return (
    <div className="mg-form-group">
      <label htmlFor={name} className="mg-sr-only">
        {label}
      </label>
      <input
        id={name}
        name={name}
        value={value}
        type="number"
        inputMode="numeric"
        pattern="[0-9]*"
        onChange={onChange}
        className="mg-form-control"
        min="1"
        max="99"
        disabled={disabled}
      />
      {error && <small className="mg-form-text mg-form-text--error">{error}</small>}
    </div>
  );
};

export default Input;
